/**
 * package: com.inq.net
 * class: URLRequest
 * root Object
 * @constructor
 */
com.inq.net.URLRequest = function(url) {
	this.url = url;
};
$hxClasses['com.inq.net.URLRequest'] = com.inq.net.URLRequest;
/** @private @type {Array} */
com.inq.net.URLRequest.__name__ = ["com","inq","net","URLRequest"];
/** @type {string} */
com.inq.net.URLRequest.prototype.url = null;
/** @type {string} */
com.inq.net.URLRequest.prototype.method = null;
/** @type {null} */
com.inq.net.URLRequest.prototype.data = null;
/** @type {string} */
com.inq.net.URLRequest.prototype.contentType = null;
/** @type {com.inq.net.URLRequest} */
com.inq.net.URLRequest.prototype.__class__ = com.inq.net.URLRequest;
